import { combineReducers } from "@reduxjs/toolkit";

import appReducer from "./app/reducer";
import authReducer from "./auth/reducer";
import mapReducer from "./map/reducer";
import directionReducer from "./direction/reducer";
import placeReducer from "./place/reducer";

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  map: mapReducer,
  direction: directionReducer,
  place: placeReducer,
});

export default rootReducer;
